import { ARCHIVE_WIDGET_SUCCESS } from './actions';

const archiveWidgetReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case ARCHIVE_WIDGET_SUCCESS:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default archiveWidgetReducer;
